<template>
<!-- loading screen, displays gif of ecg heart -->
  <div :class="{ loader: true, fadeout: !isLoading }">
    <div id="heart" >
        <img class="top" src="https://media.giphy.com/media/lo9OHBZzaM7W8Lg5L0/source.gif" width="300px">
    </div>
  </div>
</template>


<script>
export default {
  name: "LoadingScreen",
  props: ["isLoading"]
};
</script>


<style>
.loader {
  background-color: white;
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: hidden;
  padding-top: 10vh;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
}
.fadeout {
  animation: fadeout 15s forwards;
}
@keyframes fadeout {
  to {
    opacity: 1;
    visibility: hidden;
  }
}
#button{
  width:450px;
  height:450px;
  position:relative;
  top:70px;
  margin:0 auto;
  text-align:center;
}
#heart img{
  position:absolute;
  left:0;
  right:0;
  top:40%;
  margin:0 auto;
  -webkit-transition: opacity 10s ease-in-out;
  -moz-transition: opacity 10s ease-in-out;
  -o-transition: opacity 10s ease-in-out;
  transition: opacity 10s ease-in-out;}
@keyframes heartFadeInOut {
  0% {
    opacity:1;
  }
  14% {
    opacity:1;
  }
  28% {
    opacity:0;
  }
  42% {
    opacity:0;
  }
  70% {
    opacity:0;
  }
}
#heart img.top { 
  animation-name: heartFadeInOut; 
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 20s;
  animation-direction: alternate;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingScreen.vue